<template>
  <f7-navbar :sliding="false">
    <f7-link
      icon-ios="material:menu"
      icon-aurora="f7:menu"
      icon-md="material:menu"
      panel-toggle="left"
      class="icon-hamburguer"
    />
    <button
      v-if="pathBack != ''"
      class="button-back"
      @click="backTo"
    >
      <img
        class="ic-back"
      >
    </button>
    <f7-nav-title
      class=""
    >
      <span v-if="text">{{ textUpperCase }}</span>
      <slot
        v-else
        name="nav-title"
      />
    </f7-nav-title>
    <f7-nav-right class="nav-right">
      <f7-chip
        class="margin-right user-name"
      >
        {{ user.contact ? user.contact.name : user.first_name }} {{ user.contact ? user.contact.surname : user.last_name }}
      </f7-chip>
      <f7-link
        popover-open=".popover-menu"
        data-popover=".my-popover"
      >
        <f7-icon
          slot="media"
          class="navbar__icon accordion__icon--user"
        />
      </f7-link>
    </f7-nav-right>
    <f7-popover
      class="popover-menu my-popover"
    >
      <f7-list>
        <f7-list-item
          link="/selection/"
          transition="f7-fade"
          popover-close
          :title="$t(selection !== 'GreenHouse' ? 'changeToGreenHouse' : 'changeToOpenAir')"
        />
        <f7-list-item
          link="/"
          popover-close
          popup-open=".delete-account-popup"
          :title="$t('delete_account')"
          @click="deleteAccountPopup"
        />
        <f7-list-item
          link="/"
          popover-close
          :title="$t('log_out')"
          @click="closeAll"
        />
      </f7-list>
    </f7-popover>
    <f7-popup
      class="delete-account-popup"
      :opened="popupOpened"
      @popup:closed="popupOpened = false"
    >
      <f7-page>
        <f7-navbar>
          <f7-nav-right>
            <f7-link popup-close>
              <span style="color: #FFFFFF">{{ $t('Button_cancel_text') }}</span>
            </f7-link>
          </f7-nav-right>
        </f7-navbar>
        <f7-block
          style="margin: 1rem; display: flex; flex-direction: column; justify-content: center; align-items: center;"
        >
          <h4 style="text-align: center;">
            ¿Quitar de esta cuenta?
          </h4>
          <p style="text-align: center;">
            Está a punto de eliminar su cuenta <span style="font-weight: bold;">{{ user.email }}</span> de VegSyst DSS Suite.
            Ésta acción no se podrá deshacer, no podrá iniciar sesión nuevamente.
          </p>
          <DxButton
            id="delete_account"
            popup-close
            style="background-color: red; color: white; margin-top: 1rem;"
            icon="remove"
            type="error"
            :text="$t('delete_account')"
            @click="deleteAccount()"
          />
        </f7-block>
      </f7-page>
    </f7-popup>
  </f7-navbar>
</template>

<script>
import {
  mapState, mapActions,
} from 'vuex';
import DxButton from 'devextreme-vue/button';
import Api from '../../services/Api';

export default {
  components: {
    DxButton,
  },
  props: {
    elements: { type: Array, default: () => [] },
    list: { type: Array, default: () => null },
    typeExport: { type: String, default: '' },
    pathBack: { type: String, default: '' },
    text: { type: String, default: '' },
  },
  data() {
    return {
      textUpperCase: '',
      isOpened: false,
      popupOpened: false,
    };
  },
  computed: {
    ...mapState('authentication', ['user', 'selection']),
  },
  beforeMount() {
    this.textUpperCase = this.text.toUpperCase();
  },
  methods: {
    backTo() {
      this.$f7.views.main.router.navigate(this.pathBack, { reloadCurrent: true });
    },
    closeAll() {
      this.isOpened = false;
      this.logout();
      this.resetDatabaseState();
      this.resetResultState();
      this.resetProjectGreenHouse();
      this.resetProjectOpenAir();
      this.resetState();
    },
    changeOpenedTrue() {
      this.isOpened = true;
    },
    changeOpenedFalse() {
      this.isOpened = false;
    },
    deleteAccountPopup() {
      this.isOpened = false;
      this.popupOpened = true;
    },
    async deleteAccount() {
      try {
        this.popupOpened = false;
        this.$f7.preloader.show();
        await Api.delete();
        await this.logout();
      } catch (reason) {
        const message = this.$helpers.getFilteredErrorMessage(reason);
        if (message.includes('incorrect authentication')) {
          this.$f7.dialog.alert(this.$t(message));
        }
        if (message.includes('default_') && !message.includes('404')) {
          this.$f7.dialog.alert(message.split('_').pop());
        } else if (!message.includes('404')) {
          this.$f7.dialog.alert(this.$t(message));
        }
      } finally {
        this.$f7.preloader.hide();
      }
      // this.logout();
      // this.resetDatabaseState();
      // this.resetResultState();
      // this.resetProjectGreenHouse();
      // this.resetProjectOpenAir();
      // this.resetState();
    },
    ...mapActions('authentication', ['logout', 'setShowLeftPanel']),
    ...mapActions('Database', ['resetDatabaseState']),
    ...mapActions('Result', ['resetResultState']),
    ...mapActions('ProjectGreenHouse', ['resetProjectGreenHouse']),
    ...mapActions('ProjectOpenAir', ['resetProjectOpenAir']),
    ...mapActions('Utilities', ['resetState']),
  },
};
</script>
<style lang="scss" scoped>
@import "../../css/mixins";
.user-name {
  display: none;
  @include md {
    display: contents;
  }
}
.chip{
  flex-direction: row-reverse;
  padding-right: 0;
  background: transparent;
}
.chip-media + .chip-label{
  margin-right: 20px!important;
}
.chip-label{
  color: black!important;
}
.chip-media{
  background: black;
}
.ic-back{
  content: url("../../static/img/ic_back.svg");
  width: 100%;
  height: 100%;
}
.button-back{
  background-color: #D6B35A;
  border: none;
}

@import '../navbar/Navbar.styles.scss';
</style>
